import React from 'react'
import { StyledLink } from './styles'

const Logo = () => <StyledLink to="/" aria-label="Home">Chester Lodge</StyledLink>

export default Logo
